/**
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-16 10:32:00
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-20 11:21:02
 * @FilePath: \hzs-nutra-wecom-shop\src\utils\api\myTeam.js
 * @Description: 我的团队
 */

import req from "@/utils/axios.js";
export default {
    // 员工所属组织树
    _departmentTree(params) {
        return req.get("/wxShop/shop/clerk/departmentTree", {
            ...params
        })
    },
    // 获取成员
    _myTeamMember(params) {
        return req.get("/wxShop/shop/clerk/list", {
            ...params
        })
    },
    // 获取成员（含离职）
    _myTeamMemberAll2(params) {
        return req.get("/wxShop/shop/clerk/all", {
            ...params
        })
    },

    // 获取岗位
    _positionList(params) {
        return req.get("/wxShop/shop/positions", {
            ...params
        })
    },

    // 根据用户手机号获取姓名
    _msgByPhone(params) {
        return req.get("/wxShop/shop/clerk/byPhone", {
            ...params
        })
    },

    _addMember(data) {
        return req.post("/wxShop/shop/clerk/add", data)
    },
    _editMember(data) {
        return req.post("/wxShop/shop/clerk/edit", data)
    },

    // 解绑
    _unbind(data) {
        return req.post("/wxShop/shop/clerk/del", data)
    }
}